export const PASSWORD_RESET_STORAGE_KEY = 'password-reset';
export const COUNTDOWN_START = 3;
export const COUNTDOWN_INTERVAL_MS = 1000;
